module.exports = {
	"app.intro": " ",
	"app.footer-info": " ",
	"app.footer-copyright": "© Copyright&nbsp;",
	"app.footer-sign": "&nbsp;Cuyo Aval – Todos los derechos reservados",
	"app.min_specs_headline": "",
	"app.min_specs_subheading": "",
	"app.min_specs": "",
	"app.how_it_works": "",
	"app.faq1": "",
	"app.faq2": "",
	"app.step_guarantor_type_bond": " ",
	"app.step_ddjj": "<h4><p>Recordá que la información que adjuntes tiene carácter de declaración jurada</p></h4><p>Por favor <a href=\"https://www.cuyoaval.com.ar/index.php/blog/terminos-y-condiciones\" target=\"_blank\">abrir, leer y aceptar</a> con CuyoAval.com.ar</p>",
	"app.step_has_attorney": " ",
	"app.step_pending": "<h3><b>¡Gracias por completar el formulario!.</b></h3><p>Contactarse al siguiente numero de contacto si quiere continuar con su solicitud:</p><button type=\"button\" class=\"btn btn-primary pd-simple-button pd-green-button\"><i class=\"fa fa-whatsapp fa-lg fa-whatsapp-margin \"></i> 261-247-4561</button> <div><p>Lunes a viernes de 8:00 a 16:00 hs.</p></div>",
	"app.step_rejected": "<h3><b>¡Lo sentimos!.</b></h3><h4><p>Por el momento no se puede iniciar la solicitud de crédito</p></h4><p>¡Gracias por contactarte con nosotros!</p><p>Podés comunicarte con nosotros a los números: </p>",
	"app.step_rejected_investment": "",
	"app.step_rejected_investment_contact": "",
	"app.step_main": "<h3>Completá el formulario con los datos reales de la persona o empresa beneficiaria del aval</h3>",
	"app.step_start": "<h4 class='red-text'>¡Bienvenido! <br> Estás por comenzar tu solicitud de aval on line.</h4>",
	"app.step_startup_info": "<p class=\"red-text\">Se consideran Start Ups o PyMES nuevas a aquellas personas o empresas que se están iniciando en la actividad objeto del financiamiento</b>",
	"app.step_loan_line": "<h3>Muy bien! Estás en condiciones de iniciar la solucitud.</h3>",
	"app.step_general_warranty": "<h3>Elegí el tipo de garantía</h3>",
	"app.step_warranty": "<h3>Elegí el tipo de garantía</h3>",
	"app.step_fields": "<h3>Completá los siguientes campos</h3>",
	"app.step_ca_warranty": "<h3>Elegí el tipo de garantía</h3>",
	"app.step_winecellar_info": "<h3>Por favor ingresá los datos de la bodega</h3>",
	"app.step_guarantor": "<h3>Seleccioná el tipo de garante</h3>",
	"app.step_guarantor_info": "<h3>Ingresá los datos del Garante</h3>",
	"app.step_surety": "<h3>Ingresá los datos del Fiador.</h3>",
	"app.step_loan_reason": "<h3>Describí el destino del financiamiento</h3>",
	"app.step_loan_description": "<h3>Completa el monto que necestás solicitar</h3><p>Los datos que completes serán evaluados para su aprobación</p>",
	"app.step_pry_address": "<h3>Completá con los datos del inmueble del proyecto</h3>",
	"app.step_pry_rol": "<h3>Seleccioná el vínculo con el inmueble del proyecto</h3>",
	"app.step_sms": "<h3>Hemos enviado un SMS a tu celular, por favor ingresá ese código para continuar</h3>(el sms puede demorar unos segundos)",
	"app.step_sms_whatsapp_number": "2612474561",
	"app.step_sms_whatsapp_text": "Tengo+una+consulta",
	"app.step_sms_whatsapp_label": "261-247-4561",
	"app.whatsapp_timetable": "<p class=\"pd-opening-hours\">Lunes a viernes de 8:00 a 16:00 hs. </p>",
	"app.renaper_step": "A continuación efectuaremos una validación de tu identidad a través del Registro Nacional de las Personas (RENAPER)",
	"app.renaper_step_form": "Este botón te llevará a la página del RENAPER, una vez que hayamos validado tu idendidad podrás seguir con tu solicitud en nuestra web.",
	"app.step_cbu": "<h3>Último paso!</h3><p>Por favor ingresá el CBU de una cuenta sueldo a tu nombre (para depositar el préstamo y debitar la cuota)</p>",
	"app.step_address": "<h3>Ingresá tu domicilio especial</h3>",
	"app.step_confirm_address": "<h3>¿El solicitante tiene domicilio real en Mendoza?</h3>",
	"app.step_has_property": "<h3>¿Es titular de un inmueble?</h3>",
	"app.step_incomes": "<p>Por favor ingresá la información de tu último recibo de sueldo o documentación de ingresos más reciente.</p>",
	"app.step_personal_info": "<p>Por favor ingresá tu información personal y los servicios que tenés disponible en tu domicilio.</p>",
	"app.step_service_info": "<p>Por favor ingresá tu información personal y los servicios que tenés disponible en tu domicilio.</p>",
	"app.step_job_info": "<p>Por favor ingresá la información de tus datos laborales.</p>",
	"app.step_email": "<p>Para continuar con tu solicitud por favor ingresá tu correo electrónico.</p>",
	"app.step_upload_info": "<p>Para continuar por favor subí una foto de tu DNI del frente / dorso, 2 servicios y tus últimos 3 bonos de sueldo.</p>",
	"app.step_product": "<h3><b>Felicitaciones</b> estás <b>Pre-APROBADO!</b></h3><p>Para continuar, elegí el monto y las cuotas a solicitar:</p>",
	"app.step_product_label_quota": "cuota",
	"app.step_loan_type": "<h3>Muy bien! <br> Estás en condiciones de iniciar una solicitud.</h3>",
	"app.step_loan_type_credit": "<p>Seleccioná la línea de crédito:</p>",
	"app.step_loan_type_investment": "",
	"app.step_company_type": "",
	"app.step_amount": "<h3>Ingresá el monto a financiar</h3>",
	"app.step_check_address": "<h3>Por favor completá la siguiente información.</h3>",
	"app.step_check_dpj_number": "<h3>Por favor completá la siguiente información.</h3>",
	"app.step_available_amount": "El monto máximo de aval es:",
	"app.step_available_amount_description": " ",
	"app.step_dpj_form": "<h3>Ingresá el número de expediente digital</h3>",
	"app.step_upload": "<p>Para continuar por favor subí una foto de tu DNI del frente / dorso, 2 servicios y tus últimos 3 bonos de sueldo.</p>",
	"app.step_checkout": "<p>Aceptar estos documentos tienen carácter de declaración jurada.</p>",
	"app.step_members": "<h3>Por favor completá los datos.</h3>",
	"app.step_members_os": "<h3>Ingresar el/los CUIT de cada uno de los Miembros.</h3>",
	"app.step_members_ss": "<h3>Te pedimos que completes los datos de cada uno de los socios.</h3>",
	"app.step_vineyards": "<h3>Por favor ingresá los datos de los viñedos a los que destinarás el crédito.</h3>",
	"app.step_vineyard_types": "<h3>Por favor ingresá la cantidad de quintales totales que vas a cosechar según tipo de uva.</h3>",
	"app.contract_advice": "<p>Por favor, abrir, leer y acordar con FTYC</p>",
	"app.step_checkout_requested_amount": "Monto del Préstamo:",
	"app.step_checkout_quota_amount": "Valor de la cuota:",
	"app.step_checkout_requested_quotas": "Cuotas:",
	"app.step_checkout_other_costs": "Costos Administrativos:",
	"app.step_checkout_first_payment_date": "Pago de la cuota:",
	"app.step_checkout_first_payment_date_info": "Del 1 al 10 de cada mes.",
	"app.step_checkout_info": "El pago se realiza via Débito Automático desde la cuenta donde se depositó el préstamo.",
	"app.step_email_verification": "<h3><b>Para finalizar tu solicitud hacé click en el link que te enviamos a tu correo electrónico.</b></h3>",
	"app.disapproved": "<h3><b>Lo sentimos! Por el momento no se puede iniciar la solicitud de crédito.</b></h3>",
	"app.disapproved_description": "<p class=\"red-text\">El o los siguientes CUIT registran incumplimiento.</p>",
	"app.greetings_modal": "<h3><b>Gracias por contactarte con nosotros!</b></h3><p> Cualquier duda o consulta que tengas podés comunicarte con nuestro Centro de Atención On Line.</p><p>Saludos!</p>",
	"app.step_documents": "<h3>Por favor, adjuntá la siguiente informacion.</h3>",
	"app.step_deposit": "<h3><p>Por favor indícanos la modalidad de depósito.</p></h3>",
	"app.step_credit_card": "<h3><p>Por favor ingresá los datos solicitados de tu tarjeta.</p></h3>",
	"app.step_congratulations_whatsapp_number": "261-247-4561",
	"app.step_congratulations_whatsapp_text": "Tengo+una+consulta",
	"app.step_congratulations_whatsapp_label": "261-247-4561",
	"app.step_congratulations_title": "<h3><b>Te enviamos un mail con la confirmación del inicio de tu solicitud aval on line.</b></h3><p class=\"red-text\">En los próximos días un Asesor se comunicará con vos para acompañarte en el proceso de obtención de tu aval.</p>",
	"app.step_congratulations_info": " ",
	"app.step_congratulations_footer": "<p>Si tenés alguna duda o consulta comunicate con nuestro Centro de Atención On Line.</p>",
	"app.step_congratulations_salute": "¡Saludos!",
	"app.step_mza_active": " ",
	"app.step_electronic_wallet": " ",
	"app.step_amount_info": " ",
	"app.step_check_transmitter": " ",
	"app.step_check_detail": " ",
	"app.step_attorney_info": " "
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/translations/cuyoaval.json
 ** module id = 1011
 ** module chunks = 0
 **/